import { render, staticRenderFns } from "./calculator_gray_background.vue?vue&type=template&id=42b3d5b2&scoped=true&lang=pug&"
import script from "./calculator_gray_background.vue?vue&type=script&lang=js&"
export * from "./calculator_gray_background.vue?vue&type=script&lang=js&"
import style0 from "./calculator_gray_background.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./calculator_gray_background.vue?vue&type=style&index=1&id=42b3d5b2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b3d5b2",
  null
  
)

export default component.exports